/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Media_More_LabelInputs */

const vi_media_more_label = /** @type {(inputs: Media_More_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Xem thêm ${i?.count} tệp`)
};

/**

* @param {Media_More_LabelInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const media_more_label = /** @type {((inputs: Media_More_LabelInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Media_More_LabelInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_media_more_label(inputs)
});